import { render, staticRenderFns } from "./USStockQA.vue?vue&type=template&id=22dff008&scoped=true"
import script from "./USStockQA.vue?vue&type=script&lang=js"
export * from "./USStockQA.vue?vue&type=script&lang=js"
import style0 from "./USStockQA.vue?vue&type=style&index=0&id=22dff008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dff008",
  null
  
)

export default component.exports